define("shared/components/shared/upgrade/feature", ["exports", "@ember/component", "@ember/utils", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _utils, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/utils",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{#if @forCheckout}}
  
    {{#if @title}}
      <li class="tCH--featureList__li" data-test-id="title">
        <div class="tCH--featureList__text">
          {{html-safe @title}}
        </div>
      </li>
      <li class="tCH--featureList__li" ...attributes>
        {{#if (or (eq @type "boolean") this.isValueBoolean)}}
          <div class="tCH--featureStatus {{if @value 'tCH--featureStatus--active' ''}}"></div>
        {{else if (eq @type "addon")}}
          <div class="tCH--featureList__text u--text--center u--text--hair">
            {{#if (eq @value '<i class="tPF--featureStatus i-close u--text--light"></i>')}}
              {{html-safe @value}}
            {{else}}
              {{t "plans.per_month_amount" amount=(to-fixed @value decimals=2)}}
            {{/if}}
          </div>
        {{else}}
          <div class="tCH--featureList__text u--text--center u--text--hair">
            {{html-safe @value}}
          </div>
        {{/if}}
      </li>
    {{else}}
      {{#if (or (eq @type "boolean") this.isValueBoolean)}}
        <div ...attributes class="tCH--featureList__text">
          <span class="tCH--featureStatus {{if @value 'tCH--featureStatus--active' ''}}"></span>
        </div>
      {{else}}
        <div ...attributes class="tCH--featureList__text">{{html-safe @value}}</div>
      {{/if}}
    {{/if}}
  
  {{else}}
  
    {{#if @title}}
      <li class="tPF--features__li" data-test-id="title">
        <div class="tPF--features__text">
          {{@title}}
        </div>
      </li>
      <li class="tPF--features__li" ...attributes>
        {{#if (or (eq @type "boolean") this.isValueBoolean)}}
          {{#if @value}}
            {{svg-jar "check" class="tPF--featureStatus o--icon--sm"}}
          {{else}}
            {{svg-jar "close" class="tPF--featureStatus--unavailable o--icon--sm"}}
          {{/if}}
        {{else}}
          <div class="tPF--features">
            {{html-safe @value}}
          </div>
        {{/if}}
      </li>
    {{else}}
  
      {{#if (or (eq @type "boolean") this.isValueBoolean)}}
        <div ...attributes class="tPF--features__text">
          {{#if @value}}
            {{svg-jar "check" class="tPF--featureStatus o--icon--sm"}}
          {{else}}
            {{svg-jar "close" class="tPF--featureStatus--unavailable o--icon--sm"}}
          {{/if}}
        </div>
      {{else if (eq @type "addon")}}
        <div ...attributes class="tPF--features__text">
          {{#if (eq @value '<i class="tPF--featureStatus i-close u--text--light"></i>')}}
            {{html-safe @value}}
          {{else}}
            {{t "plans.per_month_amount" amount=(to-fixed @value decimals=2)}}
          {{/if}}
        </div>
      {{else}}
        <div ...attributes class="tPF--features__text">
          {{html-safe @value}}
        </div>
      {{/if}}
    {{/if}}
  {{/if}}
  */
  {
    "id": "mtN26D0v",
    "block": "[[[41,[30,1],[[[1,\"\\n\"],[41,[30,2],[[[1,\"    \"],[10,\"li\"],[14,0,\"tCH--featureList__li\"],[14,\"data-test-id\",\"title\"],[12],[1,\"\\n      \"],[10,0],[14,0,\"tCH--featureList__text\"],[12],[1,\"\\n        \"],[1,[28,[35,1],[[30,2]],null]],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n    \"],[11,\"li\"],[24,0,\"tCH--featureList__li\"],[17,3],[12],[1,\"\\n\"],[41,[28,[37,2],[[28,[37,3],[[30,4],\"boolean\"],null],[30,0,[\"isValueBoolean\"]]],null],[[[1,\"        \"],[10,0],[15,0,[29,[\"tCH--featureStatus \",[52,[30,5],\"tCH--featureStatus--active\",\"\"]]]],[12],[13],[1,\"\\n\"]],[]],[[[41,[28,[37,3],[[30,4],\"addon\"],null],[[[1,\"        \"],[10,0],[14,0,\"tCH--featureList__text u--text--center u--text--hair\"],[12],[1,\"\\n\"],[41,[28,[37,3],[[30,5],\"<i class=\\\"tPF--featureStatus i-close u--text--light\\\"></i>\"],null],[[[1,\"            \"],[1,[28,[35,1],[[30,5]],null]],[1,\"\\n\"]],[]],[[[1,\"            \"],[1,[28,[35,4],[\"plans.per_month_amount\"],[[\"amount\"],[[28,[37,5],[[30,5]],[[\"decimals\"],[2]]]]]]],[1,\"\\n\"]],[]]],[1,\"        \"],[13],[1,\"\\n\"]],[]],[[[1,\"        \"],[10,0],[14,0,\"tCH--featureList__text u--text--center u--text--hair\"],[12],[1,\"\\n          \"],[1,[28,[35,1],[[30,5]],null]],[1,\"\\n        \"],[13],[1,\"\\n      \"]],[]]]],[]]],[1,\"    \"],[13],[1,\"\\n\"]],[]],[[[41,[28,[37,2],[[28,[37,3],[[30,4],\"boolean\"],null],[30,0,[\"isValueBoolean\"]]],null],[[[1,\"      \"],[11,0],[17,3],[24,0,\"tCH--featureList__text\"],[12],[1,\"\\n        \"],[10,1],[15,0,[29,[\"tCH--featureStatus \",[52,[30,5],\"tCH--featureStatus--active\",\"\"]]]],[12],[13],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],[[[1,\"      \"],[11,0],[17,3],[24,0,\"tCH--featureList__text\"],[12],[1,[28,[35,1],[[30,5]],null]],[13],[1,\"\\n\"]],[]]]],[]]],[1,\"\\n\"]],[]],[[[1,\"\\n\"],[41,[30,2],[[[1,\"    \"],[10,\"li\"],[14,0,\"tPF--features__li\"],[14,\"data-test-id\",\"title\"],[12],[1,\"\\n      \"],[10,0],[14,0,\"tPF--features__text\"],[12],[1,\"\\n        \"],[1,[30,2]],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n    \"],[11,\"li\"],[24,0,\"tPF--features__li\"],[17,3],[12],[1,\"\\n\"],[41,[28,[37,2],[[28,[37,3],[[30,4],\"boolean\"],null],[30,0,[\"isValueBoolean\"]]],null],[[[41,[30,5],[[[1,\"          \"],[1,[28,[35,6],[\"check\"],[[\"class\"],[\"tPF--featureStatus o--icon--sm\"]]]],[1,\"\\n\"]],[]],[[[1,\"          \"],[1,[28,[35,6],[\"close\"],[[\"class\"],[\"tPF--featureStatus--unavailable o--icon--sm\"]]]],[1,\"\\n\"]],[]]]],[]],[[[1,\"        \"],[10,0],[14,0,\"tPF--features\"],[12],[1,\"\\n          \"],[1,[28,[35,1],[[30,5]],null]],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]]],[1,\"    \"],[13],[1,\"\\n\"]],[]],[[[1,\"\\n\"],[41,[28,[37,2],[[28,[37,3],[[30,4],\"boolean\"],null],[30,0,[\"isValueBoolean\"]]],null],[[[1,\"      \"],[11,0],[17,3],[24,0,\"tPF--features__text\"],[12],[1,\"\\n\"],[41,[30,5],[[[1,\"          \"],[1,[28,[35,6],[\"check\"],[[\"class\"],[\"tPF--featureStatus o--icon--sm\"]]]],[1,\"\\n\"]],[]],[[[1,\"          \"],[1,[28,[35,6],[\"close\"],[[\"class\"],[\"tPF--featureStatus--unavailable o--icon--sm\"]]]],[1,\"\\n\"]],[]]],[1,\"      \"],[13],[1,\"\\n\"]],[]],[[[41,[28,[37,3],[[30,4],\"addon\"],null],[[[1,\"      \"],[11,0],[17,3],[24,0,\"tPF--features__text\"],[12],[1,\"\\n\"],[41,[28,[37,3],[[30,5],\"<i class=\\\"tPF--featureStatus i-close u--text--light\\\"></i>\"],null],[[[1,\"          \"],[1,[28,[35,1],[[30,5]],null]],[1,\"\\n\"]],[]],[[[1,\"          \"],[1,[28,[35,4],[\"plans.per_month_amount\"],[[\"amount\"],[[28,[37,5],[[30,5]],[[\"decimals\"],[2]]]]]]],[1,\"\\n\"]],[]]],[1,\"      \"],[13],[1,\"\\n\"]],[]],[[[1,\"      \"],[11,0],[17,3],[24,0,\"tPF--features__text\"],[12],[1,\"\\n        \"],[1,[28,[35,1],[[30,5]],null]],[1,\"\\n      \"],[13],[1,\"\\n    \"]],[]]]],[]]]],[]]]],[]]]],[\"@forCheckout\",\"@title\",\"&attrs\",\"@type\",\"@value\"],false,[\"if\",\"html-safe\",\"or\",\"eq\",\"t\",\"to-fixed\",\"svg-jar\"]]",
    "moduleName": "shared/components/shared/upgrade/feature.hbs",
    "isStrictMode": false
  });
  class ListComponent extends _component2.default {
    get isValueBoolean() {
      return (0, _utils.typeOf)(this.args.value) === 'boolean';
    }
  }
  _exports.default = ListComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, ListComponent);
});